import { render, staticRenderFns } from "./PropertiesButton.vue?vue&type=template&id=19f5d0eb"
import script from "./PropertiesButton.vue?vue&type=script&lang=js"
export * from "./PropertiesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports